import React, { useState, useEffect, useContext } from "react";
import TabLink from "../users/views/_partials/tabLink";
import loaderContext from "../../../context/loader/loaderContext";
import { getUsersData } from "./services/userService";
import UserOwnersMembers from "./views/_partials/userOwnersMembers";
import { useLocation } from "react-router-dom";

const Users = () => {
  const location = useLocation();

  const BASE_MKSGROUPID = process.env.REACT_APP_GROUP_ID;

  const [securityGroupId, setSecurityGroupId] = useState(
    location.state?.securityGroupId || BASE_MKSGROUPID
  );

  const [showTab, setShowTab] = useState(1);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOwner, setIsOwner] = useState(true);
  const [isRefreshData, setIsRefreshData] = useState(true);

  const { updateLoaderStatus } = useContext(loaderContext);

  useEffect(() => {
    if (location.state?.securityGroupId) {
      setSecurityGroupId(location.state.securityGroupId);
      setIsRefreshData(true); // trigger reload
    }
  }, [location.state]);

  useEffect(() => {
    const getData = async () => {
      if (isRefreshData) {
        setIsLoading(true);
        updateLoaderStatus(true);

        const response = await getUsersData(isOwner, securityGroupId);

        setUsers(response);
        updateLoaderStatus(false);
        setIsLoading(false);
        setIsRefreshData(false);
      }
    };

    getData();
  }, [isRefreshData, isOwner, securityGroupId]);

  return (
    <div className="section-wrapper">
      <div className="dash-section">
        <div className="prompt-tabs w-tabs">
          <div className="tabs-menu h-flex head-wrapper w-tab-menu">
            
            <TabLink
              tabId="1"
              href="#"
              isSelected={showTab === 1}
              onClick={() => {
                setShowTab(1);
                setUsers([]);
                setIsOwner(true);
                setIsRefreshData(true);
              }}
            >
              Owners
            </TabLink>

            <TabLink
              tabId="2"
              href="#"
              isSelected={showTab === 2}
              onClick={() => {
                setShowTab(2);
                setUsers([]);
                setIsOwner(false);
                setIsRefreshData(true);
              }}
            >
              Members
            </TabLink>

          </div>

          <div className="w-tab-content">

            {(showTab === 1 || showTab === 2) && users?.length > 0 && (
              <UserOwnersMembers
                securityGroupId={securityGroupId}  
                userList={users}
                isOwner={isOwner}
                onRefreshData={() => setIsRefreshData(true)}
              />
            )}

            {!isLoading &&
              users?.length === 0 && (
                <div className="w-layout-grid ai-collection-grid light-bg center-grid">
                  <div>No User(s) Available</div>
                </div>
              )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Users;